<mat-form-field [class.upload__native--hidden]="showV2Error">
  <mat-label>{{ label }} </mat-label>
  <input
    matInput
    [placeholder]="placeholder ?? ''"
    readonly
    [formControl]="uploadControl"
    (click)="fileInput.click()"
  />
  <input
    #fileInput
    type="file"
    id="file-input"
    accept="image/jpeg,image/jpg,image/png"
    (change)="selectImage($event)"
  />
  <mat-icon matSuffix (click)="fileInput.click()">file_upload</mat-icon>

  <mat-error *ngIf="uploadControl.hasError('required')">{{
    "errors.required" | transloco
  }}</mat-error>
  <mat-error
    *ngIf="
      uploadControl.hasError('imageType') && !uploadControl.hasError('required')
    "
    >{{ "errors.incorrectImageType" | transloco }}</mat-error
  >
</mat-form-field>

<!-- v2 error label — shown when the host form drives its own dropzone. -->
<span class="field__error" *ngIf="showV2Error && errorKey">{{ errorKey | transloco }}</span>
